<aside class="side"
       [ngClass]="{'open': showSideNav}">
   <nav class="side__nav">
      <a [routerLink]="['/novelties']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-articles"></i> Novinky</a>
      <a [routerLink]="['/appearance']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-dashboard"></i> Vzhled</a>
      <a [routerLink]="['/settings']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-settings"></i> Nastavení</a>
      <a [routerLink]="['/menu']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-menu"></i> Menu</a>
      <a [routerLink]="['/contacts']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-newsletter"></i> Kontakty</a>
      <a [routerLink]="['/homepage']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-homepage"></i> Homepage</a>
      <a [routerLink]="['/pages']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-pages"></i> Stránky</a>
      <a [routerLink]="['/real-estate']"
         *ngIf="modules.realEstate"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-real-estate"></i> Reality</a>
      <nav class="side__nav__sub"
           *ngIf="router.isActive('real-estate', false)">
         <a routerLinkActive="side__nav__sub__link--active"
            class="side__nav__sub__link"
            [routerLink]="['/real-estate/formrecords']">Vyplněné formuláře</a>
      </nav>
      <a [routerLink]="['/appointments']"
         *ngIf="modules.appointments"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-booking"></i> Kalendáře</a>
      <nav class="side__nav__sub"
           *ngIf="router.isActive('appointments', false) && calendars && calendars.length > 0">
         <a *ngFor="let calendar of calendars"
            routerLinkActive="side__nav__sub__link--active"
            class="side__nav__sub__link"
            [routerLink]="['/appointments/calendar', calendar.id]">{{ getTitle(calendar) }}</a>
      </nav>
      <a [routerLink]="['/bookings']"
         *ngIf="modules.bookings"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-booking"></i> Rezervace</a>
      <nav class="side__nav__sub"
           *ngIf="router.isActive('bookings', false) && booking_offers && booking_offers.length > 0">
         <a *ngFor="let booking_offer of booking_offers"
            routerLinkActive="side__nav__sub__link--active"
            class="side__nav__sub__link"
            [routerLink]="['/bookings/booking_overview', booking_offer.id]">{{ getTitle(booking_offer) }}</a>
      </nav>
      <a [routerLink]="['/products']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-box"></i> Produkty</a>
      <a [routerLink]="['/career']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-users"></i> Kariéra</a>
      <a [routerLink]="['/certs']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-certificates"></i> Certifikáty</a>
      <a [routerLink]="['/footer']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-menu"></i> Patička</a>
      <a [routerLink]="['/forms']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-forms"></i> Formuláře</a>
      <nav class="side__nav__sub"
           *ngIf="router.isActive('forms', false)">
         <a routerLinkActive="side__nav__sub__link--active"
            class="side__nav__sub__link"
            [routerLink]="['/forms/view', 0]">Kontakt</a>
         <a *ngFor="let form of forms"
            routerLinkActive="side__nav__sub__link--active"
            class="side__nav__sub__link"
            [routerLink]="['/forms/view', form.id]">{{ form.title }}</a>
      </nav>
      <a [routerLink]="['/files']"
         class="side__nav__link"
         routerLinkActive="side__nav__link--active">
         <i class="side__nav__link__icon ico-media"></i> Galerie</a>
   </nav>
</aside>